import { useTaskEvents } from "@/hooks/use-task-events";
import { useEffect, useRef } from "react";

interface UploadSubscriberProps {
	uploadId: string;
	onEvent: (event: string, data: unknown) => void;
	onComplete: () => void;
}

/**
 * Подписывается на события одной upload-задачи.
 * Монтируется с key={uploadId}, поэтому каждая новая загрузка получает свежий инстанс
 * useTaskEvents без stale state из предыдущей задачи.
 */
export function UploadSubscriber({ uploadId, onEvent, onComplete }: UploadSubscriberProps) {
	const { done } = useTaskEvents(uploadId, onEvent);

	const onCompleteRef = useRef(onComplete);
	onCompleteRef.current = onComplete;

	useEffect(() => {
		if (done) onCompleteRef.current();
	}, [done]);

	return null;
}
